"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var apiModele = _interopRequireWildcard(require("@/api/modele"));

var apiModeleLot = _interopRequireWildcard(require("@/api/modele_lot"));

var apiModeleLotDetail = _interopRequireWildcard(require("@/api/modele_lot_detail"));

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var apiLot = _interopRequireWildcard(require("@/api/lot"));

var apiLotDetail = _interopRequireWildcard(require("@/api/lotdetail"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'Modele',
  data: function data() {
    return {
      etape: 0,
      status: 0,
      idAffaire: 0,
      idSociete: 0,
      lots: [],
      lotsDetail: [],
      // ---
      formDataOpen: [],
      formDataSave: {},
      dlgSaveAsVisible: false,
      rules: {
        libelle: {
          required: true,
          message: 'Champs obligatoire'
        }
      },
      // ---
      dlgOpenVisible: false,
      // ---
      CONST: CONST
    };
  },
  mounted: function mounted() {
    // EventBus.$on('REFRESH', () => {
    this.status = this.affaire.affaire.status || 0;
    this.etape = this.affaire.affaire.etape || 0;
    this.idAffaire = this.affaire.affaire.id || 0;
    this.idSociete = this.affaire.affaire.id_societe || 0;
    this.lots = this.affaire.lots;
    this.lotsDetail = this.affaire.lotsDetail; // })
  },
  computed: {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    }
  },
  methods: {
    handleCommand: function handleCommand(command) {
      var _this = this;

      switch (command) {
        case 'open':
          this.formDataOpen = [];
          apiModele.getAllBySocieteId(this.$store.getters.user.id_societe).then(function (results) {
            _this.formDataOpen = results;
            _this.dlgOpenVisible = true;
          });
          break;

        case 'saveas':
          this.formDataSave = {};

          if (this.lots.length > 0 || this.lotsDetail.length > 0) {
            this.dlgSaveAsVisible = true;
          } else {
            this.$message.error('Aucune donnée à enregistrer');
          }

          break;
      }
    },
    handleCancel: function handleCancel() {
      this.$refs['ElForm'].resetFields();
      this.dlgSaveAsVisible = false;
    },
    handleSaveAs: function handleSaveAs() {
      var _this2 = this;

      this.$refs['ElForm'].validate(function (valid) {
        if (valid) {
          _this2.saveAll();
        }
      });
    },
    saveAll: function () {
      var _saveAll = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this3 = this;

        var modele, idModele;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                modele = {
                  id_societe: this.idSociete,
                  libelle: this.formDataSave.libelle,
                  description: this.formDataSave.description,
                  id_user: this.$store.getters.user.id,
                  user_infos: this.$store.getters.user.firstname + ' ' + this.$store.getters.user.lastname
                };
                _context.next = 4;
                return apiModele.insert(modele).then(function (result) {
                  return result.insertId;
                });

              case 4:
                idModele = _context.sent;

                if (idModele > 0 && this.lots.length > 0) {
                  this.lots.forEach(function (lot, index) {
                    apiModeleLot.insert({
                      id_modele: idModele,
                      ordre: index + 1,
                      libelle: lot.libelle
                    }).then(function (result) {
                      var idModeleLot = result.insertId;

                      var details = _this3.lotsDetail.filter(function (x) {
                        return x.id_lot === lot.id && x.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE;
                      });

                      details.forEach(function (detail, index) {
                        apiModeleLotDetail.insert({
                          id_modele_lot: idModeleLot,
                          ordre: index + 1,
                          libelle: detail.libelle,
                          id_debourseIndirect: detail.id_debourseIndirect
                        });
                      });
                    });
                  });
                }

                this.dlgSaveAsVisible = false;
                this.$message('Modèle enregistré avec succès');
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                this.dlgSaveAsVisible = false;
                this.$message(_context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function saveAll() {
        return _saveAll.apply(this, arguments);
      }

      return saveAll;
    }(),
    handleOpen: function handleOpen(modele) {
      var _this4 = this;

      this.dlgOpenVisible = false;
      this.$confirm("L'ouverture de ce modèle va remplacer les lots déjà saisis. Voulez-vous continuer ?", 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning',
        closeOnClickModal: false
      }).then(function () {
        _this4.actionOpen(modele);
      });
    },
    actionOpen: function () {
      var _actionOpen = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee4(modele) {
        var _this5 = this;

        var ModeleLot, idsModeleLot, ModeleLotDetail, data;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.idAffaire > 0)) {
                  _context4.next = 15;
                  break;
                }

                _context4.next = 3;
                return apiAffaire.clean(this.idAffaire);

              case 3:
                _context4.next = 5;
                return apiModeleLot.getAllByModeleId(modele.id);

              case 5:
                ModeleLot = _context4.sent;
                // creation des lignes de détail de chaque lot
                idsModeleLot = ModeleLot.map(function (x) {
                  return x.id;
                }).join(',');
                _context4.next = 9;
                return apiModeleLotDetail.getAllByModeleLotId(idsModeleLot);

              case 9:
                ModeleLotDetail = _context4.sent;
                ModeleLot.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3(lot) {
                    var idLot, details;
                    return _regenerator.default.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return _this5.insertLot(lot);

                          case 2:
                            idLot = _context3.sent;
                            details = ModeleLotDetail.filter(function (x) {
                              return x.id_modele_lot === lot.id;
                            });
                            details.forEach( /*#__PURE__*/function () {
                              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(detail) {
                                return _regenerator.default.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        _context2.next = 2;
                                        return _this5.insertLotDetail(idLot, detail);

                                      case 2:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2);
                              }));

                              return function (_x3) {
                                return _ref2.apply(this, arguments);
                              };
                            }());

                          case 5:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }()); // mise à jour de l'affaire

                data = {
                  mt_remise_commerciale: 0,
                  mt_total_vente_initiale: 0,
                  id_modele: modele.id
                };
                _context4.next = 14;
                return apiAffaire.update(this.idAffaire, data);

              case 14:
                // rechargement de la page
                _eventBus.EventBus.$emit('REFRESH_ROUTER');

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function actionOpen(_x) {
        return _actionOpen.apply(this, arguments);
      }

      return actionOpen;
    }(),
    // -------------------------------
    insertLot: function () {
      var _insertLot = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee5(lot) {
        var data, id;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                data = {
                  id_affaire: this.idAffaire,
                  ordre: lot.ordre,
                  libelle: lot.libelle
                };
                _context5.next = 3;
                return apiLot.insert(data).then(function (result) {
                  return result.insertId;
                });

              case 3:
                id = _context5.sent;
                return _context5.abrupt("return", id);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function insertLot(_x4) {
        return _insertLot.apply(this, arguments);
      }

      return insertLot;
    }(),
    insertLotDetail: function () {
      var _insertLotDetail = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee6(idLot, detail) {
        var data, id;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = {
                  id_lot: idLot,
                  ordre: detail.ordre,
                  libelle: detail.libelle,
                  mt_vente_initiale: 0,
                  id_debourseIndirect: detail.id_debourseIndirect
                };
                _context6.next = 3;
                return apiLotDetail.insert(data).then(function (result) {
                  return result.insertId;
                });

              case 3:
                id = _context6.sent;
                return _context6.abrupt("return", id);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function insertLotDetail(_x5, _x6) {
        return _insertLotDetail.apply(this, arguments);
      }

      return insertLotDetail;
    }()
  }
};
exports.default = _default;